import type { GetBenefitBannerQuery, VipAccessResponse } from '../../models';

interface IsLoadingParams {
  benefitBannerData: GetBenefitBannerQuery | undefined;
  error: Error | undefined;
  isAnonymousWithStore: boolean;
  loadingVipAccess: boolean;
  orderOnBehalfVisible: boolean;
}

export const isLoading = ({
  benefitBannerData,
  error,
  isAnonymousWithStore,
  loadingVipAccess,
  orderOnBehalfVisible,
}: IsLoadingParams): boolean =>
  loadingVipAccess ||
  (!isAnonymousWithStore && !orderOnBehalfVisible && benefitBannerData === undefined && error === undefined);

export const isOrderOnBehalfVisible = (orderOnBehalfData: VipAccessResponse | undefined): boolean =>
  !!orderOnBehalfData?.VipAccessData?.ConsultantName &&
  !!orderOnBehalfData.VipAccessData.ConsultantNumber &&
  !!orderOnBehalfData.VipAccessLabels?.ConsultantChangeConsultantNumber &&
  orderOnBehalfData.VipAccessData.Links.length > 0;

interface ShouldSkipBenefitBannerFetchParams {
  enableTopAreaBanner?: boolean;
  isAnonymousWithStore: boolean;
  loadingSegmentationData: boolean;
  orderOnBehalfVisible: boolean;
}

export const shouldSkipBenefitBannerFetch = ({
  enableTopAreaBanner,
  isAnonymousWithStore,
  loadingSegmentationData,
  orderOnBehalfVisible,
}: ShouldSkipBenefitBannerFetchParams): boolean =>
  loadingSegmentationData || orderOnBehalfVisible || !enableTopAreaBanner || isAnonymousWithStore;
